// removed by extract-text-webpack-plugin
module.exports = {"SeverityRed":"SeverityRed--1Y_sf","SeverityYellow":"SeverityYellow--3jRbw","ReportTable":"ReportTable--3NbYd"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Home/ReportGrid.scss
// module id = 946
// module chunks = 1